export enum Tooltip {
  CREDIT_CARD_UNVERIFIED_BILLER = 'Płatność kartą wymaga weryfikacji dostawcy. Kliknij, aby dowiedzeć się więcej.',
  AMOUNT_TOO_LOW = 'Kwota płatności zbyt niska. Wybierz inną metodę.',
  CUSTOMER_BLOCKED = 'Konto zablokowane. Kliknij, aby dowiedzieć się więcej.',
  DISABLED_METHOD_TOOLTIP = 'Metoda płatności chwilowo niedostępna',
}
